export const homeAccordion = (accordionName) => {
  const accordions = accordionName
    ? document.querySelectorAll(`[data-accordion=${accordionName}]`)
    : document.querySelectorAll(`[data-accordion]`);

  if (!accordions.length) {
    return;
  }

  const accordionClickHandler = (event, accordion) => {
    const accordionWrapper = accordion.closest('.section-content');
    const accordionImage = accordionWrapper?.querySelector('.accordion-content-image');
    const clickedHeader = event.target.closest('.accordion-header');
    const accordionItem = clickedHeader.closest('.accordion-item');
    const content = accordionItem.querySelector('.accordion-content');
    const newImageSrc = accordionItem.dataset.img;

    if (accordionItem.classList.contains('accordion-item-active')) {
      return;
    }

    if (newImageSrc && accordionImage) {
      accordionImage.classList.add('in-change');

      setTimeout(() => {
        accordionImage.src = newImageSrc;
        accordionImage.onload = () => accordionImage.classList.remove('in-change');
      }, 200);
    }

      accordion.querySelectorAll('.accordion-item').forEach(item => {
        if (item !== accordionItem) {
          item.classList.remove('accordion-item-active');
          item.querySelector('.accordion-content').style.maxHeight = null;
        }
      });
      content.style.maxHeight = content.scrollHeight + "px";
      accordionItem.classList.add('accordion-item-active');
  };

  accordions.forEach(accordion => {
    const headers = accordion.querySelectorAll('.accordion-header');
    headers.forEach(header => {
      if (!header.classList.contains('event-attached')) {
        header.addEventListener('click', (event) => accordionClickHandler(event, accordion));
        header.classList.add('event-attached');
      }

      const accordionItem = header.closest('.accordion-item');
      if (accordionItem.classList.contains('accordion-item-active')) {
        const content = accordionItem.querySelector('.accordion-content');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
};

export const tableAccordion = () => {
  const accordions = document.querySelectorAll('.table-accordion');

  if (!accordions.length) {
    return;
  }

  const tableAccordionClickHandler = (event, accordion) => {
    const header = accordion.querySelector('.table-accordion-header');
    const content = accordion.querySelector('.table-accordion-content');

    if (!(header && content)) {
      return;
    }

    if (header.classList.contains('active')) {
      header.classList.remove('active');
      content.style.maxHeight = null;
    } else {
      header.classList.add('active');
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };

  accordions.forEach(accordion => {
    const header = accordion.querySelector('.table-accordion-header');
    const content = accordion.querySelector('.table-accordion-content');
    
    if (!(header && content)) {
      return;
    }

    if (!header.classList.contains('event-attached')) {
      header.addEventListener('click', (event) => tableAccordionClickHandler(event, accordion));
      header.classList.add('event-attached');
    }

    if (header.classList.contains('active') && content) {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
};
